import { OutlinedInput } from '@mui/material';
import { CustomFieldProps } from 'components/Form/components/Field/types';
import React from 'react';

export const DateInput: React.FC<CustomFieldProps<string>> = (
  props: CustomFieldProps<string>
): React.ReactElement => {
  const { value, onChange } = props;

  const handleChange = React.useCallback(
    (event: React.ChangeEvent<HTMLInputElement>): void => {
      onChange(event.target.value);
    },
    [onChange]
  );

  // <input type="date"> only accepts YYYY-MM-DD, the backend may send a full timestamp
  const dateValue = typeof value === 'string' ? value.slice(0, 10) : '';

  return <OutlinedInput type="date" value={dateValue} fullWidth={true} onChange={handleChange} />;
};
